module.exports = "/assets/data/cc9e71c83a98e01f9e588d6f798f6697-NG13.data.json";